import {post} from '@/api'
const moduleUser={
    state: {
        token:''    
    },
    mutations: {
        SET_TOKEN:(state,payload)=>{
            state.token=payload.token
        },
        LOG_OUT:(state)=>{
            state.token=''
        }
    },
    actions: {
        doLogin({commit},data){
            return new Promise((resolve,reject)=>{
                post("/login/doLogin",{username:data.username,password:data.password}).then((data)=>{
                    if(data.result.success){
                        commit("SET_TOKEN",{token:data.result.info.token})
                    }
                    resolve(data)
                }).catch((error)=>reject(error));
            }).catch(()=>{})
        },
        doMLogin({commit},data){
            return new Promise((resolve,reject)=>{
                post("/login/doMLogin",{mobile:data.mobile,code:data.code}).then((data)=>{
                    if(data.result.success){
                        commit("SET_TOKEN",{token:data.result.info.token})
                    }
                    resolve(data)
                }).catch((error)=>reject(error));
            }).catch(()=>{})
        },
        doLogout({commit}){
            return new Promise((resolve,reject)=>{
                post("/login/doLogout",{}).then(()=>{
                }).catch((error)=>reject(error));
                commit("LOG_OUT")
                resolve(1)
            }).catch(()=>{})
        }
    }
}

export default moduleUser